module.exports = __webpack_public_path__ + "img/net-people.6e9c79f4.svg";